

import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetCategoriesApi } from "../redux/actions/Categories/GetCategoriesAction";
import { AddCategoryAPI } from "../redux/actions/Categories/AddCategoryAction";
import { EditCategoryAPI } from "../redux/actions/Categories/EditCategoryAction"; // You'll need to create this

import { PulseLoader } from "react-spinners";
import Table from "../components/Table";
import Pagination from "../components/Pagination";
import { showErrorToast, showSuccessToast } from "../helpers/toast";
import { getImageUrl } from "../helpers/utils";

const Category = () => {
  const columns = ["Category Name", "Icon",'Created On', "Action"];
  const dispacth = useDispatch();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const [totalItems, setTotalItems] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(0);
  const [categories, setCategories] = React.useState([]);
  const { response, loading, error } = useSelector((state) => state.categories);
  const dispatch = useDispatch();
  const {
    loading: addLoading,
    response: addResponse,
    error: addError,
  } = useSelector((state) => state.addCategory);
  const {
    loading: editLoading,
    response: editResponse,
    error: editError,
  } = useSelector((state) => state.editCategory); // Add this selector

  // Add category states
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [preview, setPreview] = useState(null);

  // Edit category states
  const [editName, setEditName] = useState("");
  const [editImage, setEditImage] = useState(null);
  const [editPreview, setEditPreview] = useState(null);
  const [editingCategory, setEditingCategory] = useState(null);


  // Add Category File Handler
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;


    if (file.size > 10 * 1024) {
      // 5KB limit
      showErrorToast("File size should not exceed 5KB.");
      setImage(null);
      setPreview(null);
      return;
    }

    setImage(file);
    const reader = new FileReader();
    reader.onload = (e) => setPreview(e.target.result);
    reader.readAsDataURL(file);
  };

  // Edit Category File Handler
  const handleEditFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

  

    if (file.size > 10 * 1024) {
      // 5KB limit
      showErrorToast("File size should not exceed 10KB.");
      setEditImage(null);
      setEditPreview(null);
      return;
    }

    setEditImage(file);
    const reader = new FileReader();
    reader.onload = (e) => setEditPreview(e.target.result);
    reader.readAsDataURL(file);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setCurrentPage(1);
  };

  const fetchCategories = useCallback(async () => {
    try {
      await dispacth(GetCategoriesApi({ page: currentPage, limit }));
    } catch (error) {
      console.log(error);
    }
  }, [currentPage, limit, dispacth]);

  const handleSubmit = async () => {
    if (!name.trim()) {
      showErrorToast("Category name is required");
      return;
    }
    if (!image) {
      showErrorToast("Please upload an icon");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("icon", image);

    dispatch(AddCategoryAPI(formData));
  };

  const handleEditSubmit = async () => {
    if (!editName.trim()) {
      showErrorToast("Category name is required");
      return;
    }

    const formData = new FormData();
    formData.append("name", editName);
    formData.append("categoryId", editingCategory._id);

    if (editImage) {
      formData.append("icon", editImage);
    }

    dispatch(EditCategoryAPI(formData));
  };

  const openEditModal = (category) => {
    setEditingCategory(category);
    setEditName(category.name || "");
    setEditImage(null);
    setEditPreview(
      category.category_image
        ? getImageUrl(category.category_image)
        : null
    );
  };

  const closeEditModal = () => {
    setEditingCategory(null);
    setEditName("");
    setEditImage(null);
    setEditPreview(null);
  };

  const handleRetry = () => {
  window.location.reload(); // or trigger your data-fetching again
};


  // Clear Add Category modal when closed
  useEffect(() => {
    const modalElement = document.getElementById("addCategory");
    const handleModalClose = () => {
      setName("");
      setImage(null);
      setPreview(null);
    };

    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", handleModalClose);
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener("hidden.bs.modal", handleModalClose);
      }
    };
  }, []);

  // Add category effects
  useEffect(() => {
    if (addResponse) {
      showSuccessToast("Category added successfully!");
      setName("");
      setImage(null);
      setPreview(null);
      fetchCategories();
      window.$("#addCategory").modal("hide");
    }
  }, [addResponse]);

  useEffect(() => {
    if (addError) {
      showErrorToast(addError.data || "Failed to add category");
    }
  }, [addError]);

  // Edit category effects
  useEffect(() => {
    if (editResponse) {
      showSuccessToast("Category updated successfully!");
      closeEditModal();
      fetchCategories();
      window.$("#editCategory").modal("hide");
    }
  }, [editResponse]);

  useEffect(() => {
    if (editError) {
      showErrorToast(editError.data || "Failed to update category");
    }
  }, [editError]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  useEffect(() => {
    if (response?.status === true) {
      setCategories(response?.data?.list);
      setCurrentPage(response?.data?.page);
      setTotalPages(response?.data?.totalPages);
      setTotalItems(response?.data?.totalItems);
    }
  }, [response]);

  return (
    <>
      <div className="content-wrapper">
        <section className="main-section spacer-y">
          <div className="container">
            <div className="row gy-4">
              <div className="common_sub_heading_wrapper">
                <h2>Categories</h2>
                <button
                  className="primary-btn"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#addCategory"
                  aria-controls="addCategory"
                >
                  Add Category
                </button>
              </div>
              <div className="col-12">
                {loading ? (
                  <div
                    style={{ height: "40vh" }}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <PulseLoader size={25} color="#49a496" />
                  </div>
                ) : error ? (
                
                  <div className="center-container">
                    <div className="error-box">
                      <i className="bi bi-exclamation-triangle-fill"></i>
                      <p>Something went wrong</p>
                      <button className="retry-btn" onClick={handleRetry}>
                        Try Again
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    <Table
                      tableData={categories}
                      setDataList={setCategories}
                      limit={limit}
                      columns={columns}
                      currentPage={currentPage}
                      handlePageChange={handlePageChange}
                      setLimit={handleLimitChange}
                      title={"Categories"}
                      onEditCategory={openEditModal} // Pass the edit handler
                    />
                    {categories?.length > 0 && (
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        limit={limit}
                        totalItems={totalItems}
                        handlePageChange={handlePageChange}
                        handleLimitChange={handleLimitChange}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Add Category Modal */}
      <div
        className="modal fade"
        id="addCategory"
        tabIndex={-1}
        aria-labelledby="addCategoryLabel"
        data-bs-backdrop="static"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content border-0">
            <div className="modal-header border-0">
              <div>
                <h2 className="modal-title fs-5" id="addCategoryLabel">
                  Add Category
                </h2>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body py-2">
              <div className="ofcvs_form">
                <div className="ofcvs_form_item">
                  <label className="fs-14 mb-1">Name</label>
                  <div className="ofcvs_form_field">
                    <input
                      type="text"
                      className="form-control border-secondary"
                      placeholder="Enter Category Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                </div>
               
                <div className="modal_upload_file mt-3">
                          <input
                            type="file"
                            className="d-none"
                            id="dragDropFile"
                            //accept=".svg"
                            onChange={handleFileChange}
                          />

                          <label htmlFor="dragDropFile" className="upload-box">
                            {!preview ? (
                              <span className="vstack align-items-center gap-1 text-center">
                                <img src="/assets/images/document-upload.png" alt="upload" />
                                <span>Upload Icon here</span>
                                <small className="text-muted">(Only max 10KB)</small>
                              </span>
                            ) : (
                              <div className="csv-preview mt-2">
                                <img src={preview} alt="SVG Preview" className="preview-img" />
                              </div>
                            )}
                          </label>
                        </div>

              </div>
              <div className="modal-footer p-3 border-0">
                <button
                  type="button"
                  className="primary-btn m-0"
                  onClick={handleSubmit}
                  disabled={addLoading}
                >
                  {addLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Category Modal */}
      <div
        className="modal fade"
        id="editCategory"
        tabIndex={-1}
        aria-labelledby="editCategoryLabel"
        data-bs-backdrop="static"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content border-0">
            <div className="modal-header border-0">
              <div>
                <h2 className="modal-title fs-5" id="editCategoryLabel">
                  Edit Category
                </h2>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeEditModal}
              />
            </div>
            <div className="modal-body py-2">
              <div className="ofcvs_form">
                <div className="ofcvs_form_item">
                  <label className="fs-14 mb-1">Name</label>
                  <div className="ofcvs_form_field">
                    <input
                      type="text"
                      className="form-control border-secondary"
                      placeholder="Enter Category Name"
                      value={editName}
                      onChange={(e) => setEditName(e.target.value)}
                    />
                  </div>
                </div>
                {/* <div className="modal_upload_file mt-3">
                  <input
                    type="file"
                    className="d-none"
                    id="editDragDropFile"
                    accept=".svg"
                    onChange={handleEditFileChange}
                  />
                  <label htmlFor="editDragDropFile">
                    <span className="vstack align-items-center gap-1">
                      <span>
                        <img src="/assets/images/document-upload.png" />
                      </span>
                      <span>Upload New Icon (Optional)</span>
                    </span>
                    {editPreview && (
                      <div className="csv-preview mt-4">
                        <img src={editPreview} alt="SVG Preview" />
                      </div>
                    )}
                  </label>
                </div> */}

                <div className="modal_upload_file mt-3">
                <input
                  type="file"
                  className="d-none"
                  id="editDragDropFile"
                 // accept=".svg"
                  onChange={handleEditFileChange}
                />

                <label htmlFor="editDragDropFile" className="upload-box">
                  {!editPreview ? (
                    <span className="vstack align-items-center gap-1 text-center">
                      <img src="/assets/images/document-upload.png" alt="upload" />
                      <span>Upload New Icon (Optional)</span>
                      <small className="text-muted">(Only max 10KB)</small>
                    </span>
                  ) : (
                    <div className="csv-preview mt-2">
                      <img src={editPreview} alt="SVG Preview" className="preview-img" />
                    </div>
                  )}
                </label>
              </div>

              </div>
              <div className="modal-footer p-3 border-0">
                <button
                  type="button"
                  className="primary-btn m-0"
                  onClick={handleEditSubmit}
                  disabled={editLoading}
                >
                  {editLoading ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Category;
